const PROD_PORTAL = 'https://www.vuelto.ar';

/**
 * Origen del portal público (tienda, invitaciones, fiado).
 * `EXPO_PUBLIC_CUSTOMER_PORTAL_URL` es el nombre canónico;
 * `EXPO_PUBLIC_FIADO_PORTAL_URL` queda como alias de Preview/EAS viejos.
 */
type CustomerPortalEnv = {
  EXPO_PUBLIC_CUSTOMER_PORTAL_URL?: string | undefined;
  EXPO_PUBLIC_FIADO_PORTAL_URL?: string | undefined;
};

export function customerPortalBaseUrl(env?: CustomerPortalEnv): string {
  const source = env ?? process.env;
  const primary = source.EXPO_PUBLIC_CUSTOMER_PORTAL_URL?.trim();
  const legacy = source.EXPO_PUBLIC_FIADO_PORTAL_URL?.trim();
  return (primary || legacy || PROD_PORTAL).replace(/\/$/, '');
}
